import { useContext, useEffect, useState } from "react";
import { SidebarContext } from "../../../context/SidebarContext.js";
import SectionMenuLeft from "../../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import "./DriverSettings.css";
import { config } from "../../../config.js";
import { ToastContainer, toast } from "react-toastify";
import { RiDeleteBin6Line } from "react-icons/ri";
import { LuArrowLeft } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function DriverSettings() {
  const navigate = useNavigate()
  const { isSidebar } = useContext(SidebarContext);
  const [driverSettings, setDriverSettings] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [extraFields, setExtraFields] = useState([]);
  const [removedFields, setRemovedFields] = useState([]); // track removed original fields
  const [isLoading, setIsLoading] = useState(false);

  const fetchSettings = async () => {
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}constants/global?type=driver`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const result = await response.json();

      if (result.status) {
        setDriverSettings(result.data);
        setFormValues({ ...result.data, minimumWalletBalance: result.data.minimumWalletBalance ?? -200 });
      } else {
        setDriverSettings(null);
        setFormValues({});
      }
    } catch (error) {
      console.error("fetching settings failed:", error);
      setDriverSettings(null);
      setFormValues({});
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleChange = (
    key,
    value,
    isExtra = false,
    isKeyChange = false,
    index = null,
  ) => {
    if (isExtra) {
      setExtraFields((prev) =>
        prev.map((f, i) => {
          if (i === index) {
            if (isKeyChange) return { ...f, key: value };
            return { ...f, value };
          }
          return f;
        }),
      );
    } else {
      setFormValues((prev) => ({ ...prev, [key]: value }));
    }
  };

  const addExtraField = () => {
    setExtraFields((prev) => [...prev, { key: "", value: "" }]);
  };

  const removeExtraField = (index) => {
    setExtraFields((prev) => prev.filter((_, i) => i !== index));
  };

  const removeOriginalField = (key) => {
    setRemovedFields((prev) => [...prev, key]);
    setFormValues((prev) => {
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Merge original and extra fields
    const dataToSubmit = { ...formValues };
    extraFields.forEach((f) => {
      if (f.key && f.value) dataToSubmit[f.key] = f.value;
    });

    // Remove deleted original fields
    removedFields.forEach((f) => delete dataToSubmit[f]);

    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}constants/global?type=driver`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
          body: JSON.stringify(dataToSubmit),
        },
      );

      const result = await response.json();
      if (result.status) {
        toast.success("Driver settings updated successfully");
        setDriverSettings(result.data);
        setFormValues(result.data);
        setExtraFields([]);
        setRemovedFields([]);
      } else {
        toast.error(result.message || "Failed to update settings");
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Update failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />
            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
              >
                <div className="main-content-inner">
                  <div className="main-content-wrap">
                    <ToastContainer />
                    <form
                      className="form-new-product form-style-1"
                      onSubmit={handleSubmit}
                    >
                      <div className="flex items-center justify-between mb-4 gap-3">
                        <div className="flex items-center gap-3">
                          <button
                            className="back-btn flex items-center gap-2"
                            onClick={() => navigate("/")}
                          >
                            <LuArrowLeft size={16} />
                            {/* <span>Back</span> */}
                          </button>

                          <h5 className="fare-heading">
                           Driver Settings
                          </h5>
                        </div>
                      </div>
                      {/* Render original settings */}
                      {driverSettings &&
                        Object.keys({ ...driverSettings, minimumWalletBalance: driverSettings.minimumWalletBalance ?? -200 }).map((key) => {
                          if (key === "id" || removedFields.includes(key))
                            return null;
                          return (
                            <fieldset
                              className="name"
                              key={key}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <div className="body-title">{key === "minimumWalletBalance" ? "Minimum wallet balance (₹)" : key}</div>
                              <input
                                type="number"
                                name={key}
                                value={formValues[key] || ""}
                                onChange={(e) =>
                                  handleChange(key, e.target.value)
                                }
                                placeholder={`Enter ${key}`}
                              />
                              <button
                                type="button"
                                className="removeBtn"
                                onClick={() => removeOriginalField(key)}
                              >
                                <RiDeleteBin6Line className="minusIcon" />
                              </button>
                            </fieldset>
                          );
                        })}

                      {/* Render extra fields */}
                      {extraFields.map((f, index) => (
                        <fieldset
                          className="name"
                          key={index}
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          <div className="body-title">Field Name</div>
                          <input
                            type="text"
                            name={`key-${index}`}
                            value={f.key}
                            onChange={(e) =>
                              handleChange(
                                f.key,
                                e.target.value,
                                true,
                                true,
                                index,
                              )
                            }
                            placeholder="Field Name"
                          />
                          <input
                            type="text"
                            name={`value-${index}`}
                            value={f.value}
                            onChange={(e) =>
                              handleChange(
                                f.key,
                                e.target.value,
                                true,
                                false,
                                index,
                              )
                            }
                            placeholder="Value"
                          />
                          <button
                            type="button"
                            className="removeBtn"
                            onClick={() => removeExtraField(index)}
                          >
                            <RiDeleteBin6Line className="minusIcon" />
                          </button>
                        </fieldset>
                      ))}

                      <div className="subBtnCon" style={{ marginTop: "12px" }}>
                        <button
                          type="button"
                          className="addBtn"
                          onClick={addExtraField}
                        >
                          Add More
                        </button>
                        <button
                          type="submit"
                          className="btn"
                          disabled={isLoading}
                        >
                          {isLoading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DriverSettings;
